// extracted by mini-css-extract-plugin
export default {"wrapper":"NoDataAvailableImage_wrapper__4p8fz"};